import React from 'react'

const Manual_generacion_de_qr = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
    <div className="mt-16">
     <h2 className="font-bold xl:text-[40px] lg:text-4xl md:text-4xl text-4xl text-[#002D33] mb-5">
     Yappy - Generación de QR
     </h2>
     <p className="text-lg text-gray-700 mb-6">
     Esta guía proporciona un proceso sencillo para generar códigos QR con Yappy, lo
     que facilita la gestión de pagos.
     </p>
     <iframe
          src="https://scribehow.com/embed/Yappy__Generacion_de_QR__u-kevq07S9qcd64Jcvr4ow?as=scrollable"
          className="scribe-iframe-yappy-4"
          width="100%"
          height="2800"
          allowFullScreen
          style={{
            aspectRatio: '1 / 1',
            border: 0,
            minHeight: '480px'
          }}
      ></iframe>
   </div>
   </div>
  )
}

export default Manual_generacion_de_qr